import React, { Component } from 'react';
import { Context } from '~/UI/Modal/Modal';

interface Props {
	children: React.ReactNode;
}

export default class ModalContent extends Component<Props> {
	render() {
		const { children } = this.props;

		return <Context.Consumer>{(styles) => <div className={styles.content}>{children}</div>}</Context.Consumer>;
	}
}
